import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	triggerButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMoreLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMoreLinkIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	triggerButton: {
		id: 'native-issue-table.common.issue-cells.issue-links.trigger-button',
		defaultMessage: 'See more',
		description: 'Label for trigger button to open a dialog with a list of more items',
	},
	showMoreLink: {
		id: 'native-issue-table.common.issue-cells.issue-links.show-more-link',
		defaultMessage: 'Go to all linked issues',
		description: 'Label for link that redirects users to a JQL search for all linked issues',
	},
	showMoreLinkIssueTermRefresh: {
		id: 'native-issue-table.common.issue-cells.issue-links.show-more-link-issue-term-refresh',
		defaultMessage: 'Go to all linked work items',
		description: 'Label for link that redirects users to a JQL search for all linked issues',
	},
});
export default messages;
